module.exports = __webpack_public_path__ + "img/kefu.e96c7270.jpg";